/**
 * What a cell of DOR / LOR says it compares with when a repricing pass is open (CU-869fmm944, UX Obs. 4, 6).
 * The engine tags each cell's previous with `previous_pass = {execution_id, at, id_search}`, `at` = "YYYY-MM-DD HH:MM"
 * of that pass's search (gate 2, 1 A: two sites of one column may compare with different passes).
 */
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function parts(at) {
	const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(at || ''))
	return m ? { y: m[1], mon: MONTHS[Number(m[2]) - 1], d: m[3], hm: `${m[4]}:${m[5]}` } : null
}

/** "27 Oct 08:00" */
export function shortAt(at) {
	const p = parts(at)
	return p ? `${p.d} ${p.mon} ${p.hm}` : ''
}

/** "27 Oct 2026, 08:00" */
export function longAt(at) {
	const p = parts(at)
	return p ? `${p.d} ${p.mon} ${p.y}, ${p.hm}` : ''
}

/** The two tooltips of the cell: of the % and of the grey previous price. Report mode: the texts of before. */
export function compareTooltips(previousPass) {
	if (!previousPass) return { diff: 'Difference between current price and previous price', previous: 'Previous Price' }
	const text = `Vs the previous pass that searched this cell (${shortAt(previousPass.at)})`
	return { diff: text, previous: text }
}

/** The detail's line: "Previous: 37.1 · pass of 27 Oct 2026, 08:00 (the last one that searched this cell)". */
export function previousLine(previousPrice, previousPass) {
	if (!previousPass || previousPrice == null) return null
	return `Previous: ${previousPrice} · pass of ${longAt(previousPass.at)} (the last one that searched this cell)`
}

/** The table's subtitle with a pass open (UX Obs. 4). `section` is 'dor' or 'lor'. Null without a pass. */
export function passSubtitle({ pass, office, section, lor, date }) {
	if (!pass) return null
	const when = pass.slot ? longAt(String(pass.slot).replace('T', ' ')) : ''
	const why = pass.reason === 'force' ? 'by hand' : 'scheduled'
	const lors = Array.isArray(lor) ? lor : (lor != null ? [lor] : [])
	const axis = section === 'lor'
		? (date ? `pick-up ${Array.isArray(date) ? date[0] : date}` : null)
		: (lors.length ? `${lors.join(', ')} ${lors.length === 1 && Number(lors[0]) === 1 ? 'day' : 'days'}` : null)
	return ['Repricing pass', when, why, office, axis, '% vs the previous pass that searched each cell']
		.filter(Boolean).join(' · ')
}
